import { Divider } from '@mui/material';
import { INTEGRATION_PROVIDERS } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { withSuspenseBoundary } from 'apps/app/src/components/utility/SuspenseBoundary';
import { useActivatedIntegration } from 'apps/app/src/hooks/use-activated-integration';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFormErrorNotificationContext } from '../../../../../../../contexts/form-error-notification-context/form-error-notification-context';
import { useChargeContext } from '../../../charge-context';
import type { NewPlanForm } from '../../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { CREATE_PLAN_TABS } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { ChargeEditDrawerContentItemOptional } from '../ChargeEditDrawerContentItemOptional';
import { NetSuiteProductsDropdown } from './NetSuiteProductsDropdown';

const ProductErpIdSelector: React.FC = () => {
  const { itemIndex: productIndex } = useChargeContext();
  const enableDropdown = useActivatedIntegration(INTEGRATION_PROVIDERS.netSuite, { suspense: true });
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();
  const { register, getValues, control } = useFormContext<PlanInputForm, NewPlanForm>();
  const registerErpMetadata = register(`fixedProducts.${productIndex}.erpMetadata`);
  
  const [erpIdSelectorChecked, setErpIdSelectorChecked] = useState<boolean>(isNotNullOrUndefined(getValues(registerErpMetadata.name)));
  registerErrorField(registerErpMetadata.name, CREATE_PLAN_TABS.serviceFees);

  return enableDropdown ? (
    <>
      <Divider/>
      <ChargeEditDrawerContentItemOptional
        fieldPath={registerErpMetadata.name}
        label='Product ERP ID'
        handleOnChecked={setErpIdSelectorChecked}
        isChecked={erpIdSelectorChecked}
      >
        <NetSuiteProductsDropdown
          fieldPath={registerErpMetadata.name}
          control={control}
          showDropdown={true}
        />
      </ChargeEditDrawerContentItemOptional>
    </>
  ) : null;
};

const ProductErpIdSelectorWithSuspenseBoundary = withSuspenseBoundary(ProductErpIdSelector);

export { ProductErpIdSelectorWithSuspenseBoundary as ProductErpIdSelector };
